define(['app/modules/forms'], function(Forms) {
  var getActivityLink = function(activityId, activityName){
    var result = '<li>';
        result += '<a href="#activity' + activityId + '" data-toggle="tab" data-parent="#activitiesSections" ';
        result += 'aria-expanded="true" aria-controls="activity' + activityId + '">' + activityName + '</a></li>';

    return result;
  };

  var add = function(url, successCallback){
    $.ajax({
      type: 'POST',
      url: url,
      data: { activity: { name: '' } },
      success: function(result){
        if(result.new_activity_html){
          Forms.showSuccess(result);
          var new_html = $(result.new_activity_html);
          if (successCallback) successCallback(new_html);
          $('#activitiesSections').append(new_html);
          $('#companyForms #activities .section-list').append(getActivityLink(result.id, result.name));
          $('#activitiesSections input.radio-icheck').iCheck({ handle: 'radio' });
          $('#activitiesSections #activity_industry').chosen({
            disable_search_threshold: 10,
            width: "100%",
            allow_single_deselect: true
          });
          $('.section-list a[href="#activity' + result.id + '"]').tab('show');
        }
      }
    });
  };

  var update = function(form, prefix, successCallback){
    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function(result){
        Forms.hideErrors(form);

        if(result.errors){
          Forms.showErrors(form, result.errors, prefix, result.errors_html);
        } else {
          Forms.showSuccess(result);
          var activity = $.parseJSON(result.activity);
          if (successCallback) successCallback(result, form);
          $('a[href="#activity' + activity.id + '"]').html('<i class="fa panel-caret" />' + activity.name);
          Forms.closePanel(form.parents('.panel'));
        }
      }
    });
  };

  var destroy = function(link){
    var url = link.attr('href');
    var form = link.closest('.activity-form');
    $.ajax({
      type: 'DELETE',
      url: url,
      success: function(result){
        Forms.hideErrors(form);
        if(result.errors){
          Forms.showErrors(form, result.errors, '', result.errors_html);
        } else {
          Forms.showSuccess(result);
          $('#activitiesSections #activity' + result.id).remove();
          $('#companyForms #activities .section-list a[href="#activity' + result.id + '"]').parent().remove();
          $('#activities .section-list a:first').tab('show');
        }
      },
      error: function(result) {
        Forms.hideErrors(form);
        Forms.showErrors(form, [], '', Forms.getErrorHtml(result));
        Forms.redirectTo(result);
      }
    });
  };

  return {
    add: add,
    update: update,
    destroy: destroy
  };
});
